// Skeleton
// ---------
// A single pulsing placeholder bar. Compose several to trace the shape of
// the content that is loading — a heading bar, a couple of text lines, a
// block where an image will land.
//
// Why shape rather than a spinner: a spinner says "wait" and nothing
// else, and one spinner per action trains people to ignore them. A
// content-shaped placeholder says "this specific thing is on its way, and
// here is roughly what you're about to read", so the page stops moving
// under the reader when the real content arrives.
//
// Pair with useDelayedFlag so a fast load never flashes one of these.

import React from "react";

import { cn } from "@/lib/utils";

interface SkeletonProps {
  // Tailwind sizing / spacing for this bar, e.g. "h-4 w-40".
  className?: string;
}

function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      // Decorative: the surrounding region carries the accessible
      // "loading" announcement, so each bar would just be noise.
      aria-hidden="true"
      className={cn("animate-pulse rounded bg-gray-200/80", className)}
    />
  );
}

export default Skeleton;
